import { useEffect, useState } from 'react';

export const MOBILE_QUERY = '(max-width: 768px)';

// True at phone widths; updates live (rotation, split-screen, devtools).
// matchMedia rather than a resize listener: the browser only calls back when
// the answer actually changes.
export const useIsMobile = () => {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setMobile(e.matches);
    setMobile(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return mobile;
};

// True while the on-screen keyboard is up. The bottom tab bar hides then, so
// it doesn't ride on top of the keyboard and squash the form being typed in.
// The visual viewport shrinks well below the layout viewport when a keyboard
// opens; a small shrink (address bar collapsing) is ignored.
export const useKeyboardOpen = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    const check = () => setOpen(viewport.height < window.innerHeight * 0.75);
    check();
    viewport.addEventListener('resize', check);
    return () => viewport.removeEventListener('resize', check);
  }, []);
  return open;
};
